import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock/mock";
import logo from "../assets/atom-logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0c0a08]/90 backdrop-blur-md border-b border-[#e0b04c]/15 py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center group">
          <img
            src={logo}
            alt="A.T.O.M. - A Tribute to Frankie, Featuring Paul Bumbry"
            className={`w-auto object-contain transition-all duration-500 group-hover:scale-[1.03] ${
              scrolled ? "h-32" : "h-44"
            }`}
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-3.5 py-2 text-sm font-medium transition-colors duration-300 ${
                  active ? "text-[#e0b04c]" : "text-[#e9e2d5] hover:text-[#e0b04c]"
                }`}
              >
                {link.label}
                <span
                  className={`absolute left-3.5 right-3.5 -bottom-0.5 h-px bg-[#e0b04c] origin-left transition-transform duration-300 ${
                    active ? "scale-x-100" : "scale-x-0"
                  }`}
                />
              </Link>
            );
          })}
        </nav>

        {/* CTA */}
        <button
          onClick={() => navigate("/booking")}
          className="hidden lg:inline-flex items-center gap-2 bg-gradient-to-b from-[#e8bc55] to-[#c99339] text-[#0c0a08] font-semibold text-sm px-6 py-2.5 rounded-md hover:shadow-[0_8px_30px_rgba(224,176,76,0.35)] hover:-translate-y-0.5 transition-all duration-300"
        >
          Book A.T.O.M.
        </button>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-[#e0b04c] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#0c0a08]/98 backdrop-blur-md ${
          open ? "max-h-[500px] border-t border-[#e0b04c]/15" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-1">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`py-3 text-base font-medium border-b border-white/5 ${
                location.pathname === link.path ? "text-[#e0b04c]" : "text-[#e9e2d5]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <button
            onClick={() => navigate("/booking")}
            className="mt-3 bg-gradient-to-b from-[#e8bc55] to-[#c99339] text-[#0c0a08] font-semibold px-6 py-3 rounded-md"
          >
            Book A.T.O.M.
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
